import React from 'react';
import { Icon } from '@sravni/react-design-system';
import { ArrowRight } from '@sravni/react-icons';
import { useStyles } from '@sravni/react-utils';
import { MESSAGE_TYPE } from '../../enums/MessageTypes.js';
import { MenuItem } from '../SuggestList/MenuItem.js';
import modules_72a695e8 from './styles/Scenario.module.less.js';

function TextMessage({ msg }) {
    const cx = useStyles(modules_72a695e8);
    if (msg.autorIsUser) {
        return (React.createElement("div", { className: cx('query') },
            React.createElement("div", { className: cx('queryText') }, msg.content.items.map((msg) => (React.createElement("p", { key: msg.type === 'text' ? msg.content.text : '' }, msg.type === 'text' ? msg.content.text : ''))))));
    }
    return (React.createElement("div", { className: cx('message') },
        React.createElement("div", { className: cx('messageText') }, msg.content.items.map((msg) => (React.createElement("p", { key: msg.type === 'text' ? msg.content.text : '' }, (msg.type === 'text' ? msg.content.text : '').split('\n\n').map((text) => (React.createElement("p", { key: text }, text)))))))));
}
function MenuMessage({ msg, onAction, }) {
    const cx = useStyles(modules_72a695e8);
    return (React.createElement("div", { className: cx('message', 'messageText', 'msgItemList') }, msg.content.items.map((item) => item.type === 'menu-item' && (React.createElement(MenuItem, { className: cx('msgMenuItem'), key: item.action, onClick: () => item.action && onAction(item.action, item.text ?? '', msg.position) },
        React.createElement("span", null, item.text),
        React.createElement(Icon, { className: cx('menuItemIcon'), icon: React.createElement(ArrowRight, null) }))))));
}
function ComponentMessage({ msg }) {
    return React.createElement(React.Fragment, null, msg.content.items.map((item) => (item.type === MESSAGE_TYPE.COMPONENT ? item.content : null)));
}
function MessageList({ messages, onAction }) {
    const chooseMsgType = (msg) => {
        switch (msg.content.type) {
            case MESSAGE_TYPE.MESSAGE:
                return React.createElement(TextMessage, { msg: msg });
            case MESSAGE_TYPE.MENU:
                return React.createElement(MenuMessage, { msg: msg, onAction: onAction });
            case MESSAGE_TYPE.COMPONENT:
                return React.createElement(ComponentMessage, { msg: msg });
            default:
                return null;
        }
    };
    return React.createElement("div", null, messages.map(chooseMsgType));
}

export { MessageList };
//# sourceMappingURL=MessageList.js.map
